import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import './index.scss';
import { Head } from '../../Head';

const { Content } = Layout;

interface MainLayoutProps {}

export const MainLayout: React.FC<MainLayoutProps> = () => {
    return (
        <Layout>
            <Head />
            <Content>
                <Outlet />
            </Content>
        </Layout>
    );
};
